var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16170 -1670)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-16170 1670)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17502.82 5088.761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1347.812-3388.871q-3.532,0-7.064,0a2.816,2.816,0,0,1-2.919-2.91q-.017-3.5,0-7.01a2.822,2.822,0,0,1,2.935-2.9c3.6-.005,7.209-.011,10.813.01.49,0,.6-.141.6-.611a39,39,0,0,1,.092-4.557,5.281,5.281,0,0,1,3.758-4.565,5.362,5.362,0,0,1,5.81,1.321,5.527,5.527,0,0,1,1.721,4.19c0,1.087,0,2.174,0,3.26,0,.6-.21.851-.673.841s-.661-.252-.667-.858c-.012-1.177.009-2.355-.027-3.531a4.261,4.261,0,0,0-3.945-4.174,4.255,4.255,0,0,0-4.558,3.218,11.547,11.547,0,0,0-.189,2.318c-.03.85.013,1.7-.015,2.553-.015.438.106.619.574.594a6.062,6.062,0,0,1,1.456.07,2.742,2.742,0,0,1,2.318,2.742c.026,2.39.035,4.782,0,7.172a2.817,2.817,0,0,1-2.954,2.823Q1351.344-3388.869,1347.812-3388.871Zm.051-11.49q-3.424,0-6.847,0c-1.309,0-1.858.538-1.862,1.84-.007,1.83,0,3.659,0,5.489,0,.507-.015,1.017.033,1.52a1.336,1.336,0,0,0,1.268,1.257c.323.032.65.054.975.054q5.815.005,11.63,0c.6,0,1.2.025,1.793-.015,1.168-.079,1.634-.533,1.651-1.709q.047-3.369,0-6.739c-.017-1.175-.611-1.7-1.79-1.7Q1351.287-3400.365,1347.863-3400.361Z",
    transform: "translate(0 0)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.752-3277.221c0-.469-.006-.939,0-1.408.007-.426.2-.682.659-.681a.612.612,0,0,1,.672.677c.014.938.012,1.877,0,2.815a.616.616,0,0,1-.666.688.612.612,0,0,1-.665-.684C1423.746-3276.283,1423.752-3276.752,1423.752-3277.221Z",
    transform: "translate(-76.588 -118.054)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.faee9ae0.svg";
export { ForwardRef as ReactComponent };